import { RegularPaymentMethod } from './get-checkout-payment-availability';
import { shouldShowEstimatedWeightUi } from './should-show-estimated-weight-ui';

export function readRequiresWeightAdjustment(
  product: unknown
): boolean | null | undefined {
  if (!product || typeof product !== 'object') {
    return undefined;
  }

  if (!('requires_weight_adjustment' in product)) {
    return undefined;
  }

  const value = Reflect.get(product, 'requires_weight_adjustment');
  if (typeof value === 'boolean') {
    return value;
  }
  if (value === null) {
    return null;
  }

  return undefined;
}

export function readAllowedPaymentMethods(
  product: unknown
): ReadonlyArray<RegularPaymentMethod> | null | undefined {
  if (!product || typeof product !== 'object') {
    return undefined;
  }

  if (!('allowed_payment_methods' in product)) {
    return undefined;
  }

  const value = Reflect.get(product, 'allowed_payment_methods');
  if (value === null) {
    return null;
  }

  if (!Array.isArray(value)) {
    return undefined;
  }

  return value.filter(
    (method): method is RegularPaymentMethod =>
      method === 'cash_on_delivery' || method === 'bank_transfer'
  );
}

export function shouldShowEstimatedWeightCheckoutOrderUi(
  isFeatureEnabled: boolean,
  requiresWeightAdjustmentByProduct: ReadonlyArray<boolean | null | undefined>
): boolean {
  return requiresWeightAdjustmentByProduct.some((requiresWeightAdjustment) =>
    shouldShowEstimatedWeightUi(isFeatureEnabled, requiresWeightAdjustment)
  );
}
